import React from "react";

import { useKioskoConfig } from "../context/kiosko-config.context";
import { useCreateKioskoContext } from "../create/provider/createKiosko.provider";
import { useCreateNewsKioskoContext } from "../create/provider/createNewsKiosko.provider";
import { useCreateUsedKioskoContext } from "../create/provider/createUsedKiosko.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const config = useKioskoConfig();
  const { setFlow, setStep, step } = useCreateKioskoContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsKioskoContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedKioskoContext();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className="fixed z-[9999] w-full bg-white">
      <div className="max-w-screen flex min-h-20 md:px-32 xl:min-h-28">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="-ml-7 w-28 lg:ml-0 lg:w-36">
            <img
              alt={`${config.name}_logo`}
              src={config.logoUrl}
              className="img-fluid w-full"
            />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={handleLogout}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
